module.exports = __webpack_public_path__ + "src/assets/images/info.fabceebbd00c184c52e2a798de6d4755.svg";